/*
 * @Author: Liux
 * @Date: 2019-11-21 02:43:45
 * @LastEditor: Liux
 * @LastEditTime: 2020-05-20 16:52:25
 */
import { Component, Input } from '@angular/core';
import { AdLinkMenuItem } from './ad-link-menu-item';

@Component({
  selector: 'ad-link-menu-item',
  template: ``,
})
export class AdLinkMenuItemComponent extends AdLinkMenuItem {
  /**
   *
   */
  constructor() {
    super({});
  }

  @Input() value: any; // **required**
  @Input() name: string;
  @Input() link = '';
  @Input() routerLink: any[] = null;
  @Input() isExternal = false;
  @Input() target = '_self'; // just work with the isExternal=true
  @Input() action: any = null; // function
  @Input() selected = false;
  @Input() disabled = false;

  @Input() cssClass: any;
}
